import { render } from "./NewsletterSignup.vue?vue&type=template&id=8510b728&scoped=true"
import script from "./NewsletterSignup.vue?vue&type=script&lang=js"
export * from "./NewsletterSignup.vue?vue&type=script&lang=js"

import "./NewsletterSignup.vue?vue&type=style&index=0&id=8510b728&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8510b728"]])

export default __exports__